import React from 'react';

function AdminResults () {
  return <p>FIXME: AdminResults</p>
}

export default AdminResults;

